import React from 'react';
import styles from './TutorialPopup.module.scss';
import { tutorialIcon } from 'react-project/assets/Icons';
import cls from 'classnames';

const journeyCanvas = {
  id: 'cd5dc687-2a4b-46ac-8681-8e36d7a17b90',
  title: 'Start Your Journey',
  description: (
    <>Go through the Interactive demo to see how Funnelytics makes you a better marketer.</>
  ),
  icon: 'canvas-4.svg',
};

const canvases = [
  {
    id: 'ccf1d27c-babb-4b37-9df5-22e218b3768e',
    title: 'Performance Analytics',
    description: <>Track and analyze your marketing metrics to make informed decisions</>,
    icon: 'canvas-3.svg',
    action: 'Start Analytics Demo',
  },
  {
    id: 'c0556575-433b-4f9b-92ea-72085a449e2a',
    title: 'Revenue Forecasting',
    description: <>Master data-driven predictions to optimize your marketing budget and ROI</>,
    icon: 'forecasting.svg',
    action: 'Start Forecasting Demo',
  },
  {
    id: 'abb0b4ee-c0cb-43f2-8699-c40ebe3d1b23',
    title: 'Visual Funnel Mapping',
    description: <>Learn to map clear, actionable journeys that convert visitors into customers</>,
    icon: 'canvas-1.svg',
    action: 'Start Mapping Demo',
  },
];

export const TutorialPopup = ({ onCanvasSelection, onClickOutside, onInstallTracking }) => {
  const onSegmentClicked = (canvas) => {
    onCanvasSelection(canvas.id);
  };

  const onBackgroudClick = (e) => {
    if (e.target === e.currentTarget) {
      onClickOutside && onClickOutside();
    }
  };

  const onInstallScriptClicked = () => {
    onClickOutside && onClickOutside();
    onInstallTracking && onInstallTracking();
  };

  return (
    <div onClick={onBackgroudClick} className={styles.Background}>
      <div className={styles.Popup}>
        <div className={styles.Header}>
          <div className={styles.Icon}>{tutorialIcon}</div>
          <div className={styles.Title}> Funnelytics Demo Canvas</div>
        </div>
        <div className={cls(styles.Content, styles.JourneyTopContent)} style={{ paddingBottom: 0 }}>
          <div key={journeyCanvas.id} className={styles.JourneySegment}>
            <div className={styles.JourneyIcon}>
              <img src={`${process.env.PUBLIC_URL}/asset/tutorial/${journeyCanvas.icon}`} />
            </div>
            <div className={styles.JourneyContent}>
              <div className={styles.JourneyTitle}>{journeyCanvas.title}</div>
              <div className={styles.JourneyDescription}>{journeyCanvas.description}</div>
            </div>
            <button
              className={styles.JourneyButton}
              onClick={(e) => {
                e.stopPropagation(); // Prevent parent click handler
                onSegmentClicked(journeyCanvas);
              }}
            >
              Start Interactive Demo
            </button>
          </div>
        </div>
        <div className={styles.Content}>
          {canvases.map((canvas) => {
            return (
              <div key={canvas.id} className={styles.Segment}>
                <div className={styles.SegmentIcon}>
                  <img src={`${process.env.PUBLIC_URL}/asset/tutorial/${canvas.icon}`} />
                </div>
                <div className={styles.SegmentContent}>
                  <div className={styles.SegmentTitle}>{canvas.title}</div>
                  <div className={styles.SegmentDescription}>{canvas.description}</div>
                  <div
                    className={styles.SegmentLink}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent parent click handler
                      onSegmentClicked(canvas);
                    }}
                  >
                    {canvas.action}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
